/*!
 * name ZJX 公共尾部
 * Copyright 2018-2019
 */
<template>
  <div class="footer_content">
      <div class="footer_public_box">
         <ul class="footer_public_box_ul">
           <li>
             <div>
               <p class="p_font_bold"><a href="javascript:;">经销商入口</a></p>
               <p><a href="http://www.dzhhb.com/center.html?mod=7">诚招代理商</a></p>
             </div>
             <div>
               <p class="p_font_bold"><a href="javascript:;">帮助说明</a></p>
               <p><a href="http://www.dzhhb.com/xsfw.html">支付方式</a></p>
               <p><a href="http://www.dzhhb.com/xsfw.html">保修条款</a></p>
             </div>
             <div>
               <p class="p_font_bold"><a href="javascript:;">关于我们</a></p>
               <p><a href="http://www.dzhhb.com/center.html?mod=1">关于康智达</a></p>
               <p><a href="http://www.dzhhb.com/center.html?mod=1">联系我们</a></p>
               <p><a href="http://www.dzhhb.com/center.html?mod=3">法律声明</a></p>
             </div>
           </li>
           <li>
             <div>
                 <p class="p_font_bold"><a href="javascript:;">扫描二维码</a></p>
                 <p><img class="footer_public_img" src="../assets/images/weixin.jpg" alt=""></p>
                 <p><a href="http://dzhhb.com">乐画订阅号</a></p>
             </div>
             <div class="p_padding_top">
                 <p><img class="footer_public_img"  src="../assets/images/kzd.png" alt=""></p>
                 <p><a href="http://dzhhb.com">康智达公司</a></p>
             </div>
             <div>
               <p class="p_font_bold"><a href="javascript:;">第三方商店</a></p>
               <p><img class="footer_public_img"  src="../assets/images/jd_black.png" alt=""></p>
               <p><a href="https://mall.jd.com/index-138550.html">京东店</a></p>
              </div>
             <!--<div class="p_padding_top">-->
               <!--<p><img class="footer_public_img"  src="../assets/images/code.png" alt=""></p>-->
                <!--<p><a href="javascript:;">淘宝店</a></p>-->
             <!--</div>-->
           </li>
           <li>
              <p class="p_font_bold"><a href="javascript:;">客服热线</a></p>
              <p><a href="javascript:;">4008-100-268</a></p>
              <p><a href="javascript:;">邮箱：Lehua@dzhhb.com</a></p>
              <p><a href="javascript:;">京ICP备05016024号</a></p>
              <p><a href="javascript:;">电子绘画板 版权所有</a></p>
           </li>
         </ul>
      </div>
      <div class="footer_company_code">
          Copyright ©1996-2019 LEHUA Corporation, ALL Rights Reserved
      </div>
  </div>
</template>

<script>


export default {
  data () {
    return {

    }
  },
  computed:{

  },
  mounted(){

  },
  methods:{

  },
  watch:{

  },
  props:{

  }
}
</script>

<style lang="scss" scoped>
  .footer_content{
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    // position: absolute;
    // bottom: 0px;
    background: #15c1e4;
    .footer_public_box{
      width: 1000px;
      overflow: hidden;
      box-sizing: border-box;
      margin: 0 auto;
      .footer_public_box_ul{
         width: 1000px;
         li{
           float: left;
           height: 278px;
         }
         li:nth-child(1){
           width: 333px;
           div{
             width: 111px;
             float: left;
             height: 278px;
             box-sizing: border-box;
             padding-top:40px;
             p{
               line-height: 40px;
               a{
                 color: #fff;
               }
             }
           }
         }
         li:nth-child(2){
           width: 400px;
           div{
             float: left;
             width: 100px;
             height: 278px;
             box-sizing: border-box;
             padding-top:40px;
              p{
               line-height: 40px;
               text-align: center;
               a{
                 color: #fff;
               }
             }
           }
         }
         li:nth-child(3){
           width: 267px;
            line-height: 40px;
            padding-left: 30px;
            box-sizing: border-box;
           padding-top:40px;
               a{
                 color: #fff;
               }
         }
      }
    }
    .footer_company_code{
      width: 100%;
      height: 55px;
      background: #9dba1f;
      text-align: center;
      line-height: 55px;
      font-size: 15px;
      color: #fff;
    }
  }
  .p_font_bold{
    font-weight: bold;
  }
  .footer_public_img{
    width:60px;height:60px;
    margin-top: 30px;
  }
  .p_padding_top{
    padding-top:80px!important;
  }
</style>

